import { request } from '@/data/request';

export interface PersonalProfilePayload {
  name: string;
  email: string;
  cpf: string;
  phone: string;
  birthDate: string;
  sex?: string;
}

export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
}

export const fetchPersonalProfile = async (): Promise<any> => {
  return request<any>({
    method: 'get',
    url: '/profile/personal-info',
  });
};

export const updatePersonalProfile = async (
  payload: PersonalProfilePayload,
): Promise<any> => {
  return request<any>({
    method: 'put',
    url: '/profile/personal-info',
    data: payload,
  });
};

export const changeMyPassword = async (
  payload: ChangePasswordPayload,
): Promise<any> => {
  return request<any>({
    method: 'post',
    url: '/auth/change-password',
    data: payload,
  });
};

export const fetchMyAvatar = async (userId: string | number): Promise<any> => {
  try {
    return await request<any>({
      method: 'get',
      url: `/user/${userId}/avatar`,
    });
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const uploadMyAvatar = async (
  userId: string | number,
  file: File,
): Promise<any> => {
  const formData = new FormData();
  formData.append('avatar', file);

  return request<any>({
    method: 'post',
    url: `/user/${userId}/avatar`,
    data: formData,
  });
};
